import { ConfigInputType } from '@config/schemas/main';
import EventTypes from '@core/utilities/constants/events';

const config: ConfigInputType = {
    public: {
        root_url: 'collaborate.lausanne.org',
        apiUrl: 'api.app.commissioned.global',
        whitelabel_url: 'collaborate.lausanne.org',
        deep_link_domains: [
            'https://app.commissioned.global',
            'https://app.becommissioned.com',
            'https://app.inthezone.social',
            'https://inthezone.social',
            'https://www.inthezone.social',
            'https://app.nickv.network',
            'https://collaborate.lausanne.org',
        ],

        configName: 'production-lausanne',
        captcha: {
            key: '6LdHxaglAAAAABFfI7N2Ru-e_8s3XlioNvjbar_h',
        },
        customDeleteAccountMessage: 'Are you sure you want to delete your user profile? This action will also delete your account on the Commissioned app. This cannot be undone.',
        siteName: 'Lausanne Action Hub',
        metaInfo: {
            title: 'Lausanne Action Hub - Lausanne Movement',
            description:
                'Join with like-minded teams and individuals to collaborate on important gaps and opportunities in seeing the Great Commission fulfilled.',
            image: 'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/OWq08t8GSUC0tPKhPbAw',
            url: 'collaborate.lausanne.org',
        },
        displayPlatformFormspec: false,
        copyright: 'Lausanne Movement',

        eventTypes: [EventTypes.EVENT_GROUP, EventTypes.EVENT_LISTING],

        rootGroupId: '65bab2b1763da89439773a35',
        hideRootGroupDeleteButton: true,

        filestack: { api_key: 'A7RsW3VzfSNO2TCsFJ6Eiz', filePreview: true },
        unsplash: { access_key: 'NTNacJWbx9pMW5yHizHSqWr1IpQXmTJTuQ08VZ7pSEg' },
        Google: { Maps_API_Key: 'AIzaSyBDfzEYNC2sHOYi9OEwmwNVVtOMDFfUV5I' },
        GATracking: { GA_ID: 'G-WHJTFXR8H2' },
        sentry: {
            dsn: 'https://bd4f25c0ac1c4278b822ee7b34fdb036@o246842.ingest.sentry.io/5199016',
        },
        stripe: {
            client_api_key:
                'pk_live_51JIeveETSMEXfAr3ggqmxBjwTD1P50EVbPrKNoJkZwcxQKgXsAOncGj3SGV3S8Gf0f0hTXurPhAWuOSlQx0DmL8u00Uinne8WH',
            secret_webhook_key: 'whsec_unMQEAXsMGitj3e5bdWZdk4pEwsjh76A',
        },
        userflow: { api_key: 'ct_a4o665523nbjdgnwvidhtxrdma' },
        showGettingStarted: true,
        defaultMembershipUrl: 'welibrary',
        defaultJoinInstructions: 'commissioned_join_instructions',
        defaultGroupCodePlaceholder: 'commissioned_shortcode_placeholder',
        defaultGroupCode: 'LAHCOLLAB',
        hideGroupHeaderInfoFromLoggedOutUsers: true,
        homeButton: {
            picture:
                'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/068XRTTqTT6UkNFxCZHN',
            title: 'Lausanne Action Hub',
            groupId: '65bab2b1763da89439773a35',
        },

        homeGroups: {
            groupIds: [
                '65bab2b1763da89439773a35', // Lausanne PWA
                '8y2CNH8ToRXA4svzR', // What's Happening Now

                // This isn't *really* a home group for Lausanne
                //   ... but if we remove it then it will show up in UserOptimizers because it's a "group without a root"
                //       leaving it here solves that problem (since only one home group is included in UserOptimizers)
                '63fe33a0c9f8e7afd736a591', // The Home Zone
            ],
        },
        disableInlinePrefilledSignupLink: true,
        restrictSignupToDefaultMembership: true,

        communityGuidelines: 'commissioned.global/community-guidelines',
        privacyPolicy: 'lausanne.org/privacy',
        termsOfService: 'commissioned.global/terms-of-service',
        templatesUrl: 'templates',

        userGuide: 'lausannemovement.freshdesk.com/support/home',

        defaultLogoBackup:
            'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/UqZttrRCRwuwCvS333JX',
        defaultLogoBackupWhite:
            'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/bOyFN8DMRA6ON5fE8Lrb',
        defaultLogoBackupWhiteAlt:
            'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/j1TxrF2tRFKe11PWFDUE',
        defaultLogoBlack:
            'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/bdGZh1FySw2IHion0HSD',

        pushSenderID: 541036629111,
        pushLogo: 'co_notification',

        recommendationsMatchmakerWhitelist: ['welibrary'],

        userSnap: false,
        userSnapOverrideSrc: '//api.usersnap.com/load/81dfe074-2710-40d9-b130-d0c9be1c2c30.js',
        userSnapTesterEmails: [
            'jkramer@pneuma33.com',
            'jkramer@commissioned.io',
            'sthomas@pneuma33.com',
            'mriddell@commissioned.io',
            'michelle43770@yahoo.com',
            'kmonaghan@commissioned.io',
        ],

        bulkUserTemplate:
            'https://docs.google.com/spreadsheets/d/1kkqURN4VHJuj6KZVMMSRRuWGdV_KvdWz5BeoYj9q1SQ/edit?usp=sharing',
        bulkGenerateUserTemplate:
            'https://docs.google.com/spreadsheets/d/1LSN6MLgMmyHToHGpA4EEHZFtGPjLWxn3GsmbgM71Rdw/edit?usp=sharing',

        brandColor1: '#ffffff',
        brandColor2: '#2985C2',
        favicon: '/images/favicon/lausanne/favicon.ico',
        theme: {
            primaryColor: '#2985C2',
            primaryAccent: '#94CCC7',
            primaryHighlight: '#4594C9',
            primaryShade: '#006EB8',
            thumbHighlight: '#00B5A1',
            secondaryColor: '#00B5A1',
            hoverColor: '#006EB8',
            slideBackground:
                'url(https://cdn.filestackcontent.com/auto_image/1Wjcy7OYQCqn7b6brH4Z)',
            emptyBackground:
                'url(https://cdn.filestackcontent.com/auto_image/rZZ11ay3TYCJZNyJ1dWq)',
            coffeeBackground:
                'url(https://cdn.filestackcontent.com/auto_image/inBO4fCkSxWq6ph1lbtw)',
            docBackground: 'url(https://cdn.filestackcontent.com/auto_image/Efr6ADNQQrJsAKtcUFZb)',
        },

        companyAddress: '10524 Moss Park Road, Suite 201 #358 Orlando, FL 32832 USA',

        allowAnonymousSignups: false,
        hidePlatformGroupHeaderDisplay: false,

        pledge: {
            new_recruit_template: 'd-61eb02daf35440d59672a2acbea1a688',
            new_recruit_sms_override:
                'Congratulations on your decision to follow Jesus. To grow stronger go to https://comm.gl/frstgr. Join https://comm.gl/omwnew to grow in this faith adventure!',
            failed_recruit_template: 'd-beedc18c284c43789a2e010ceffde9e8',
            failed_recruit_sms_override:
                'Hello. Thanks for letting me share about my faith-story. I thought you might be interested in checking out my website www.frostygrapes.com. Enjoy!',
            already_recruit_template: 'd-5402723fa68b406eb9b95e9dd8504bbf',
            already_recruit_sms_override:
                'Hello, I’m glad that you’re a follower of Jesus. Learn how to tell your faith-story with pre-believers https://comm.gl/omw. You will have great joy sharing!',
            new_recruit_claim_reminder_template: 'd-4fdcddd98bc74803959ad4a51fe02b77',
            new_recruit_claim_reminder_two_template: 'd-081324f4d43048c9bfdb9e2b4196d771',
        },

        domainBranding: {
            commissioned: {
                root_url: 'app.commissioned.global',
                defaultCoverPhoto: 'https://cdn.filestackcontent.com/MVyrZRrrRSC6gXGdBHYc',
                defaultGroupCode: 'COMMISSIONED',
            },
            localhost: {
                root_url: 'collaborate.lausanne.org',
                defaultCoverPhoto:
                    'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/068XRTTqTT6UkNFxCZHN',
                defaultGroupCode: 'LAHCOLLAB',
            },
            nickv: {
                root_url: 'app.nickv.network',
                defaultCoverPhoto:
                    'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/N1KsunCQqK49JdmJW3Vz',
                defaultGroupCode: 'NICKVNETWORK',
            },
            inthezone: {
                root_url: 'www.inthezone.social',
                defaultCoverPhoto:
                    'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/m2ZTxcCBRVqLBEgBapY9',
                defaultGroupCode: 'INTHEZONE',
            },
            lausanne: {
                root_url: 'collaborate.lausanne.org',
                defaultCoverPhoto:
                    'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/068XRTTqTT6UkNFxCZHN',
                defaultGroupCode: 'LAHCOLLAB',
            },
        },
        slideMenu: {
            actionItems: true,
            mobilization: true,
            search: true,
            discover: true,
            footerText: 'common:global.patent_pending',
            showConnectionsIcon: true,
            showBookmarkIcon: true,
        },

        secondaryNavigation: {
            items: {
                mobile: ['navigator', 'groups', 'home', 'messages', 'discover'],
                desktop: ['groups', 'home', 'messages', 'discover', 'notifications', 'profile'],
            },
        },

        locize: {
            projectId: '662a9e61-2900-409c-a73e-6ba0bbfc3f38',
            apiKey: '3ff8b824-d205-42ea-be99-a366868d9f73',
            referenceLng: 'en',
        },

        ceramic: {
            nodeEndpointUrl: 'https://ceramic-node.welibrary.io:7007',
            contentFamily: 'SuperSkills',
            definitions: {
                MyVerifiableCredentials:
                    'kjzl6cwe1jw14am5tu5hh412s19o4zm8aq3g2lpd6s4paxj2nly2lj4drp3pun2',
            },
            schemas: {
                AchievementVerifiableCredential:
                    'ceramic://k3y52l7qbv1frylibw2725v8gem3hxs1onoh6pvux0szdduugczh0hddxo6qsd6o0',
                VerifiableCredentialsList:
                    'ceramic://k3y52l7qbv1frxkcwfpyauky3fyl4n44izridy3blvjjzgftis40sk9w8g3remghs',
            },
        },

        appflow: {
            liveUpdate: {
                appId: '41fef2ff',
                channel: 'production-lausanne',
                updateMethod: 'none',
            },
        },

        eventOrganizerTermsOfUseUrl:
            'https://www.commissioned.global/events-faq-for-event-organizers/',
        ticketPurchaserTermsOfUseUrl:
            'https://www.commissioned.global/events-faq-for-ticket-purchasers/',

        launchDarklyConfig: {
            clientSideID: '65caa02567b33c107599821c',
            context: {
                kind: 'user',
                key: 'anonymous',
            },
        },
        poweredBy: {
            name: 'Commissioned',
            logo: 'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/NmkVQhwNTSW9TyIcWjz1',
            whiteLogo: 'https://cdn.filestackcontent.com/rotate=deg:exif/auto_image/SKaFlNdeRZqXyPMggcWw',
            whiteLogoClassname: 'w-[50%] mt-[-20px] !ml-[50px] self-center',
            classname: 'mt-[10px] !w-[250px]'
        }
    },
};

export default config;
